import { GenIcon } from '../helpers/IconBase.es.js';

const IndicatorColored = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      { tag: "circle", attr: { cx: "12", cy: "12", r: "9", fill: "white" } },
      { tag: "circle", attr: { cx: "12", cy: "12", r: "6", fill: "#EE112E" } }
    ]
  })(props);
};

export { IndicatorColored };
